import { h, render } from "preact"
import { debounce, fetchSearchSuggestion } from "../utils/global-utilities";
import SearchResults from "./SearchResults";
import TrendingSearches from "./TrendingSearches";

export default (element, data) => {
  const searchInput = element.querySelector('[data-search-input]');
  const searchButton = element.querySelector('[data-search-button]');
  const searchResultsBox = element.querySelector('[data-search-results]');
  const trendigSearchesBox = element.querySelector('[data-trending-searches]');
  document.addEventListener('open-panel:search-panel', () => {
    if(searchInput) {
      searchInput.focus();
      setTimeout(() => {
        searchInput.classList.remove('w-[110px]');
        searchInput.classList.add('w-full');
      }, 100);
    }
  });

  document.addEventListener('close-panel:search-panel', () => {
    if(searchInput) {
      searchInput.classList.remove('w-full');
      searchInput.classList.add('w-[110px]');
    }
  });

  document.addEventListener('toggle-panel:search-panel', () => {
    if(searchInput) {
      searchInput.classList.remove('w-full');
      searchInput.classList.add('w-[110px]');
    }
  });

  if(searchInput) {
    searchInput.addEventListener('input', debounce(async (event) => {
      const { value } = event.target;

      if(value.length > 1) {
        const { resources: { results } } = await fetchSearchSuggestion(value);

        document.dispatchEvent(new CustomEvent('search', {
          detail: {
            payload: {
              query: value,
              results
            },
          },
        }));

        return;
      }

      document.dispatchEvent(new CustomEvent('search', {
        detail: {
          payload: {
            query: '',
            results: {
              products: []
            }
          }
        },
      }));
    }));

    searchInput.addEventListener('keyup', (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        window.location.href = `/search?q=${event.target.value}&type=product`;
      }
    });
  }

  if(searchButton) {
    searchButton.addEventListener('click', () => {
      window.location.href = `/search?q=${searchInput.value}&type=product`;
    });
  }

  if (searchResultsBox) {
    render(
      <SearchResults 
        defaultData={data.trending_products} 
      />, searchResultsBox
    );
  }

  if (trendigSearchesBox) {
    render(
      <TrendingSearches 
        defaultData={data.trending_searches} 
      />, trendigSearchesBox
    );
  }
};
